import { render } from "./GesSeparatas.vue?vue&type=template&id=bcb7a174"
import script from "./GesSeparatas.vue?vue&type=script&lang=js"
export * from "./GesSeparatas.vue?vue&type=script&lang=js"
script.render = render

export default script